import { PANEL_VISIBILITY_DATA_SUCCESS, CHANGE_TEMPLATE_TYPE, TOGGLE_VIEW, RESET_WORKKARD_DETAIL_DATA, RESET_PANEL_VISIBILITY } from "../actions/actionConstants";
import { CharConstants, RightPanelConstant } from '../constants';

const initialState = {
    templateType: CharConstants.Activity,
    isLeftVisible: true,
    isRightVisible: true,
    isMiddleVisible: true,
    isNoteVisible: false,
    isNoteCreationVisible: false,
    isRightPanelExpand: true,
    isVisibleExternalApp: false,
    isFullViewActive: false,
    isNotificationPanelOpen:false,
    toggleView: RightPanelConstant.NormalView,
    showWkInMobileView:false
};

export default function (state = initialState, action) {

    switch (action.type) {
        case PANEL_VISIBILITY_DATA_SUCCESS: {
            return Object.assign({}, state, action.payload);
        }
        case CHANGE_TEMPLATE_TYPE:
            return Object.assign({}, state, action.payload);
        case TOGGLE_VIEW: {
            return Object.assign({}, state, { toggleView: action.payload });
        }
        case RESET_WORKKARD_DETAIL_DATA:
            return Object.assign({}, initialState );
        case RESET_PANEL_VISIBILITY:
            return Object.assign( {}, initialState );
        default:
            return state;
    }
}